import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  useToast,
  RadioGroup,
  Radio,
  Circle,
  Stack
} from "@chakra-ui/react";
// import { Field, Form, Formik } from "formik";
import { useEffect } from "react";
import { useRef, useState } from "react";
import { ReactComponent as AddPhoto } from "../../svg/AddPhoto.svg";
import SwitchComponent from "../common/SwitchComponent";
import Tags from "../common/Tags";
import { useDispatch, useSelector } from "react-redux";
import { resetEdit, resetFormStatus, selectedMenu, setEdit, setHeaderText } from "../../redux/actions/actions";
import { useHistory } from "react-router-dom";
import {
  loadCourses,
  submitCourseForm,
  updateCourseForm,
} from "../../redux/api_calls/apiCalls";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import JoditEditor from "jodit-react";

export default function CustomAddCourse() {
  const [courseImage, setCourseImage] = useState(null);
  const [courseImageUrl, setCourseImageUrl] = useState(null)
  const [keywordTags, setKeywordTags] = useState([]);
  const [courseImageError, setCourseImageError] = useState(null);
  const [courseNameError, setCourseNameError] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);
  const [startDateError, setStartDateError] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [keywordsError, setKeywordsError] = useState(null);
  const [certificateSwitchStatus, setCertificateSwitchStatus] = useState(true);
  const [courseEnabledSwitchStatus, setCourseEnabledSwitchStatus] = useState(true);
  const [radioButtonValue, setRadioButtonValue] = useState('Beginner')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const courseNameRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const toast = useToast();

  const formStatus = useSelector((state) => state.formStatus);
  const headerText = useSelector((state) => state.headerState.headerText);
  const editState = useSelector((state) => state.editState);
  const slider = useSelector(state => state.sliderState.sliderOpen)
  const courseData = useSelector((state) => state.coursesState.coursesData);

  const editor = useRef(null)
  const [content, setContent] = useState('')

  function validateCourseName() {
    let courseName = courseNameRef.current.value.trim();
    if (!courseName.length) {
      setCourseNameError("Course Name is required");
      return true;
    } else {
      setCourseNameError(null);
      return false;
    }
  }

  function validateDescription() {
    let description = content
    if (!description.length) {
      setDescriptionError("Course Description is required");
      return true;
    } else {
      setDescriptionError(null);
      return false;
    }
  }

  function validateStartDate() {
    if (!editState.flag) {
      let error;
      let date = new Date(Date.now())
      let month = Number(date.getMonth()) + 1
      let day = Number(date.getDate())
      let today = date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
      if (!startDate.length) {
        error = "Course Start Date is required";
      } else if (Date.parse(startDate.split('-').reverse().join('-')) < Date.parse(today)) {
        error = "Course Start Date cannot be less than today!";
      } else if (endDate.length) {
        if (Date.parse(endDate.split('-').reverse().join('-')) >= Date.parse(today) && Date.parse(endDate.split('-').reverse().join('-')) < Date.parse(startDate.split('-').reverse().join('-'))) {
          error =
            "Course Start Date cannot be more than Course End Date!";
        }
      }
      if (error) {
        setStartDateError(error);
        return true;
      } else {
        setStartDateError(null);
        return false;
      }
    }
    else {
      setStartDateError(null);
      return false;
    }
  }

  function validateEndDate(value) {
    let error;
    let date = new Date(Date.now())
    let month = Number(date.getMonth()) + 1
    let day = Number(date.getDate())
    let today = date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    if (!endDate.length) {
      error = "Course End Date is required";
    } else if (Date.parse(endDate.split('-').reverse().join('-')) < Date.parse(today)) {
      error = "Course End Date cannot be less than today!";
    } else if (startDate.length) {
      if (Date.parse(startDate.split('-').reverse().join('-')) > Date.parse(endDate.split('-').reverse().join('-'))) {
        error = "Course End Date cannot be earlier than Course Start Date!";
      }
    }
    if (error) {
      setEndDateError(error);
      return true;
    } else {
      setEndDateError(null);
      return false;
    }
  }

  function validateKeyword() {
    if (!keywordTags.length) {
      setKeywordsError("No Keyword Entered");
      return true;
    } else {
      setKeywordsError(null);
      return false;
    }
  }

  function validatePhoto() {
    if (!courseImage) {
      setCourseImageError("Please select a Cover Photo for the Course!");
      return true;
    } else {
      setCourseImageError(null);
      return false;
    }
  }

  function keywordKeyPressHandler(e) {
    e.stopPropagation();
    if (e.key === "Enter" || e.key === "ENTER") {
      let currentKeyword = e.target.value.trim();
      if (currentKeyword.length) {
        let tempTags = [...keywordTags];
        tempTags.push(currentKeyword);
        setKeywordTags(tempTags);
        e.target.value = "";
        return false;
      }
    }
  }

  const validateFields = () => {
    return (
      validatePhoto() ||
      validateCourseName() ||
      validateStartDate() ||
      validateEndDate() ||
      validateDescription() ||
      validateKeyword()
    );
  };

  function removeTagHandler(keyword) {
    setKeywordTags(keywordTags.filter((tag) => tag !== keyword));
  }

  const cancelHandler = () => {
    dispatch(resetEdit());
    history.push("/courses");
  };

  const resetForm = () => {
    setCourseImage(null);
    setCourseImageUrl(null)
    courseNameRef.current.value = "";
    setStartDate('')
    setEndDate('')
    setContent('')
    setKeywordTags([]);
    setCertificateSwitchStatus(true);
    setCourseEnabledSwitchStatus(true);
  };

  const preFillForm = () => {
    let currentCourse = courseData.find((course) => course.id.toString() === editState.id.toString());
    setCourseImage(currentCourse.cover_image.replaceAll(" ", "%20"));
    setCourseImageUrl(currentCourse.cover_image.replaceAll(" ", "%20"))

    setStartDate(currentCourse.start_date.split('-').reverse().join('-'));
    setEndDate(currentCourse.end_date.split('-').reverse().join('-'));
    setCourseEnabledSwitchStatus(currentCourse.status.toUpperCase() === "Y");
    setCertificateSwitchStatus(
      currentCourse.certificate_option
        ? currentCourse.certificate_option.toUpperCase() === "Y"
        : false
    );

    setKeywordTags(currentCourse.keywords ? currentCourse.keywords.split(", ") : []);
    // descriptionRef.current.value = currentCourse.description;
    setContent(currentCourse.description)
    courseNameRef.current.value = currentCourse.title;
    /* "title": "Eius iusto autem facere dolore in error facilis.",
                "description": "Beatae et sit hic quo exercitationem. Rerum qui quas aut amet. Labore magni corrupti doloremque cum consequatur est omnis quis. Ducimus culpa omnis est.",
                "keywords": "Porro eveniet cumque nam voluptatem et ut voluptas odit.",
                "status": "Y",
                "start_date": "2021-08-29",
                "end_date": "2021-08-29",
                "attendance_option": "Y",
                "cover_image": "http://lorempixel.com/400/200/sports/",
                "quiz_option": "Y", */
  };

  useEffect(() => { }, [courseImageError]);

  useEffect(() => {
    dispatch(selectedMenu(1))
    if (history.location.state) {
      dispatch(loadCourses())
      dispatch(setEdit(history.location.state.id))
    }
    return () => {
      dispatch(resetFormStatus())
      dispatch(resetEdit())
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (editState.flag && courseData.length > 0) {
      dispatch(setHeaderText("Edit Course"));
      preFillForm();
    } else {
      dispatch(setHeaderText("Add Course"));
    }
    // eslint-disable-next-line
  }, [dispatch, editState, courseData]);

  useEffect(() => {
    if (formStatus.success && !formStatus.error) {
      if (editState.flag) {
        dispatch(resetEdit());
        toast({
          title: "Course Edited Successfully!",
          description: "Course Edited!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Course Added Successfully!",
          description: "Course Added!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
      resetForm();
      history.push("/courses");
    } else if (formStatus.error) {
      toast({
        title: "Something went wrong!",
        description: "Error!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    // eslint-disable-next-line
  }, [formStatus.success, formStatus.error]);

  const appendData = (formData) => {
    console.log(startDate, endDate, typeof (startDate))
    formData.append("level", radioButtonValue)
    formData.append("title", courseNameRef.current.value.trim())
    formData.append("description", content)
    formData.append("keywords", keywordTags.join(", "))
    formData.append("start_date", startDate.split('-').reverse().join('-'))
    formData.append("end_date", endDate.split('-').reverse().join('-'))
    formData.append("cover_image", courseImage)
    formData.append("status", courseEnabledSwitchStatus ? "Y" : "N")
    formData.append("certificate_option", certificateSwitchStatus ? "Y" : "N")
  }

  const addNewCourse = () => {
    let formData = new FormData()

    appendData(formData)

    dispatch(submitCourseForm(formData));
  };

  const updateCourse = () => {
    let formData = new FormData()
    appendData(formData)
    dispatch(updateCourseForm(formData, editState.id));
  };

  const submitHandler = () => {
    if (validateFields()) {
      return;
    } else {
      if (editState.flag) {
        updateCourse();
      } else {
        addNewCourse();
      }
    }
  };

  useEffect(() => {
    if (content.length) {
      setDescriptionError(null);
    }
  }, [content])

  useEffect(() => {
    if (courseImage) {
      if (typeof courseImage === "object") {
        let extension = courseImage.name.substring(
          courseImage.name.lastIndexOf(".") + 1
        );
        let acceptedExtensions = ["jpeg", "jpg", "png"];
        if (!acceptedExtensions.includes(extension.toLowerCase())) {
          setCourseImageError("Invalid file type");
          setCourseImageUrl(null)
          setCourseImage(null);
        }
        else if ((courseImage.size / (1024 * 1024)) > 0.5) {
          setCourseImageError("Please upload files of size less than or equal to 512 kb!");
          setCourseImageUrl(null)
          setCourseImage(null);
        }
        else {
          setCourseImageUrl(URL.createObjectURL(courseImage))
        }
      }
    }
  }, [courseImage]);

  return (
    <Box
      flexGrow="1"
      d="flex"
      justifyContent="flex-start"
      alignItems="center"
      flexDirection="column"
      minH="90vh"
      pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
      transition='all 350ms ease'
    >
      <Box
        width={["95%", "95%", "90%", "85%"]}
        justifyContent={["center", "center", "flex-start", "flex-start"]}
        alignItems={["center", "center", "flex-start", "flex-start"]}
        d="flex"
        mb="2rem"
        flexDirection="column"
      >
        <Text
          fontSize={["20px", "25px", "30px", "40px"]}
          d={["none", "none", "none", "flex"]}
          fontWeight="900"
          style={{ fontFamily: "Mulish, sans-serif" }}
          mb="2rem"
        >
          {headerText}
        </Text>
        <Box
          width={["100%", "100%", "100%", "85%"]}
          justifyContent={["center", "center", "flex-start", "flex-start"]}
          alignItems={["center", "center", "flex-start", "flex-start"]}
          d="flex"
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              width: "90%",
            }}
            pointerEvents={formStatus.isSubmitting ? 'none' : 'all'}
          >
            <FormControl isInvalid={courseImageError}>
              <FormLabel
                variant="custom"
                htmlFor="add_photo"
                style={{ fontFamily: "Mulish, sans-serif" }}
              >
                Cover Image
              </FormLabel>

              <Box width="140px" id="add_photo" mr='5rem' position='relative'>
                <label htmlFor="add_photo_helper">
                  <Button
                    as="span"
                    width="140px"
                    height="140px"
                    bg="white"
                    bgImage={courseImageUrl ? courseImageUrl : null}
                    bgRepeat='no-repeat'
                    bgSize='cover'
                    bgPosition='center'
                    borderRadius="xl"
                    fontWeight="800"
                    fontSize={["12px", "14px", "16px", "18px"]}
                    style={{ fontFamily: "Mulish, sans-serif" }}
                    color="#E4B716"
                    _hover={{ bg: "white", bgImage: courseImageUrl ? courseImageUrl : null, bgRepeat: 'no-repeat', bgSize: 'cover', bgPosition: 'center' }}
                    d="flex"
                    flexDir="column"
                    border="1px solid rgba(0, 0, 0, 0.1)"
                    cursor="pointer"
                  >
                    {
                      !courseImageUrl &&
                      <>
                        <AddPhoto style={{ marginBottom: "0.5rem" }} />
                        Add Photo
                      </>
                    }
                  </Button>
                  {
                    courseImageUrl &&
                    <Circle
                      size='30px'
                      bg='white'
                      position='absolute'
                      right='-15px'
                      bottom='10px'
                      boxShadow='xl'
                      border="1px solid rgba(0, 0, 0, 0.1)"
                      cursor='pointer'
                    >
                      <AddPhoto width='15px' height='15px' />
                    </Circle>
                  }
                </label>
                <input
                  accept="image/png, image/jpeg, image/jpg"
                  id="add_photo_helper"
                  name="add_photo_helper"
                  type="file"
                  onChange={(e) => {
                    setCourseImage(e.target.files[0]);
                    setCourseImageError(null);
                  }}
                  style={{ display: "none" }}
                />
              </Box>
              <FormErrorMessage fontSize="sm">
                {courseImageError}
              </FormErrorMessage>
              {courseImage && (
                <Text
                  mt="1"
                  fontWeight="600"
                  color="#666666"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  fontSize="md"
                >
                  Attached file :
                  <span style={{ fontSize: "13px", marginLeft: '1em' }}>
                    <em>{courseImage.name ? `${courseImage.name} - ${(courseImage.size / (1024 * 1024)).toFixed(2)} MB` : courseImage}</em>
                  </span>
                </Text>
              )}
            </FormControl>

            <FormControl isInvalid={courseNameError}>
              <FormLabel
                variant="custom"
                htmlFor="course_name"
                style={{ fontFamily: "Mulish, sans-serif" }}
              >
                Course Name
              </FormLabel>
              <Input
                id="course_name"
                width={["100%", "100%", "90%", "85%"]}
                bgColor="white"
                ref={courseNameRef}
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius="13px"
                height='40px'
                onChange={() => {
                  if (courseNameRef.current.value.trim().length > 0) {
                    setCourseNameError(null);
                  }
                }}
              />
              <FormErrorMessage fontSize="sm">
                {courseNameError}
              </FormErrorMessage>
            </FormControl>

            <FormControl>
              <FormLabel
                variant='custom'
                htmlFor='course-type'
                style={{ fontFamily: 'Mulish, sans-serif' }}
              >
                Course Type
              </FormLabel>
              <RadioGroup style={{ fontFamily: 'Mulish, sans-serif' }} color="#666666" fontWeight='600' fontSize='16px' onChange={setRadioButtonValue} value={radioButtonValue}>
                <Stack direction="row" spacing={8}>
                  <Radio value="Beginner" >Beginner</Radio>
                  <Radio value="Intermediate" >Intermediate</Radio>
                  <Radio value='Advanced'>Advanced</Radio>
                </Stack>
              </RadioGroup>
            </FormControl>

            <Box
              width={["100%", "100%", "90%", "85%"]}
              d="flex"
              justifyContent="space-between"
            >
              <Box width="45%">
                <FormControl isInvalid={startDateError}>
                  <FormLabel
                    variant="custom"
                    htmlFor="start_date"
                    style={{ fontFamily: "Mulish, sans-serif" }}
                  >
                    Start Date
                  </FormLabel>

                  <Flatpickr
                    value={startDate}
                    options={
                      { dateFormat: 'd-m-Y' }
                    }
                    placeholder='dd-mm-yyyy'
                    onChange={(date, dateStr) => {
                      setStartDate(dateStr)
                      setStartDateError(null)
                    }}
                    style={{ padding: '1rem', color: '#666666', width: '100%', height: '40px', backgroundColor: 'white', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                  />

                  <FormErrorMessage fontSize="sm">
                    {startDateError}
                  </FormErrorMessage>
                </FormControl>
              </Box>
              <Box width="45%">
                <FormControl isInvalid={endDateError}>
                  <FormLabel
                    variant="custom"
                    htmlFor="end_date"
                    style={{ fontFamily: "Mulish, sans-serif" }}
                  >
                    End Date
                  </FormLabel>

                  <Flatpickr
                    value={endDate}
                    options={
                      { dateFormat: 'd-m-Y' }
                    }
                    placeholder='dd-mm-yyyy'
                    onChange={(date, dateStr) => {
                      setEndDate(dateStr)
                      setEndDateError(null)
                    }
                    }
                    style={{ padding: '1rem', color: '#666666', width: '100%', height: '40px', backgroundColor: 'white', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                  />

                  <FormErrorMessage fontSize="sm">
                    {endDateError}
                  </FormErrorMessage>
                </FormControl>
              </Box>
            </Box>

            <FormControl isInvalid={descriptionError}>
              <FormLabel
                variant="custom"
                htmlFor="course_description"
                style={{ fontFamily: "Mulish, sans-serif" }}
              >
                Course Description
              </FormLabel>

              <Box width={["100%", "100%", "90%", "85%"]} bg='white' borderRadius='13px' minH='200px' >
                <JoditEditor
                  ref={editor}
                  value={content}
                  config={{
                    readOnly: false,
                    uploader: { url: 'none' },
                    removeButtons: ["image", "video", "file", "table", "fullsize", "link", "find"],
                    disablePlugins: ["image-properties", "image-processor", "image", "video", "media", "file", "table", "class-span", "resize-cells", "select-cells", "table-keyboard-navigation", "print", "preview", "fullsize", "search", "link"],
                  }}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                  onChange={newContent => { }}
                />
              </Box>
              <FormErrorMessage fontSize="sm">
                {descriptionError}
              </FormErrorMessage>
            </FormControl>


            <FormControl isInvalid={keywordsError} onSubmit={() => false}>
              <FormLabel
                variant="custom"
                htmlFor="keywords"
                style={{ fontFamily: "Mulish, sans-serif" }}
              >
                Keywords
              </FormLabel>
              <Box
                d="flex"
                bgColor="white"
                width={["100%", "100%", "90%", "85%"]}
                p="1"
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius="13px"
                minHeight='59px'
                flexWrap="wrap"
              >
                <Box
                  d={keywordTags.length > 0 ? "flex" : "none"}
                  justifyContent="flex-start"
                  flexWrap="wrap"
                >
                  {keywordTags.length > 0 &&
                    keywordTags.map((tag, idx) => (
                      <Tags
                        keyword={tag}
                        removeTag={removeTagHandler}
                        key={idx}
                      />
                    ))}
                </Box>
                <Input
                  id="keywords"
                  bgColor="white"
                  placeholder="Enter Keyword"
                  onKeyDown={keywordKeyPressHandler}
                  border="none"
                  outline="none"
                  p="5px"
                  minW="40%"
                  focusBorderColor="none"
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  fontWeight="600"
                  fontSize="16px"
                  onChange={() => setKeywordsError(null)}
                  height='100%'
                  color='#999999'
                />
              </Box>
              <FormErrorMessage fontSize="sm">{keywordsError}</FormErrorMessage>
            </FormControl>


            <Box
              width={["100%", "100%", "90%", "85%"]}
              d="flex"
              justifyContent="space-between"
            >
              <Text
                width={["55%", "65%", "65%", "65%", "75%"]}
                style={{ fontFamily: "Mulish, sans-serif" }}
                fontWeight="600"
                fontSize={["16px", "16px", "16px", "18px"]}
                color="#666666"
              >
                Is certificate applicable for this course?
              </Text>
              <SwitchComponent
                trueText="Yes"
                falseText="No"
                bgColor="#94c0ff"
                switchStatus={certificateSwitchStatus}
                setSwitchStatus={setCertificateSwitchStatus}
              />
            </Box>
            <Box
              width={["100%", "100%", "90%", "85%"]}
              d="flex"
              justifyContent="space-between"
            >
              <Text
                width={["55%", "65%", "65%", "65%", "75%"]}
                style={{ fontFamily: "Mulish, sans-serif" }}
                fontWeight="600"
                fontSize={["16px", "16px", "16px", "18px"]}
                color="#666666"
              >
                Course Status
              </Text>
              <SwitchComponent
                trueText="Enable"
                falseText="Disable"
                bgColor="#fb5f3a"
                switchStatus={courseEnabledSwitchStatus}
                setSwitchStatus={setCourseEnabledSwitchStatus}
              />
            </Box>
            <Box
              width={["100%", "100%", "90%", "85%"]}
              d="flex"
              flexDir={["column", "column", "row", "row"]}
              justifyContent={["center", "center", "flex-start", "flex-start"]}
              mt="2rem"
            >
              <Button
                bgColor="#fd5f3a"
                color="white"
                borderRadius="lg"
                p={["6px 15px", "8px 20px", "12px 30px"]}
                _hover={{ bg: "#fd6f4c" }}
                isLoading={formStatus.isSubmitting}
                loadingText={editState.flag ? "Updating..." : "Adding..."}
                onClick={submitHandler}
                style={{ fontFamily: "Mulish, sans-serif" }}
                fontWeight="800"
                fontSize={["13px", "14px", "16px"]}
                mr={["0", "0", "20px", "20px"]}
                mb={["20px", "20px", "0", "0"]}
              >
                {editState.flag ? "Update Course" : "Add Course"}
              </Button>
              <Button
                bgColor="white"
                color="#999999"
                borderRadius="lg"
                border="1px solid rgba(0, 0, 0, 0.2)"
                p={["6px 15px", "8px 20px", "12px 30px"]}
                style={{ fontFamily: "Mulish, sans-serif" }}
                fontWeight="800"
                fontSize={["13px", "14px", "16px"]}
                onClick={cancelHandler}
              >
                Cancel
              </Button>
            </Box>
            {/* {formStatus.error && (
              <Text
                fontSize="sm"
                style={{ fontFamily: "Mulish, sans-serif" }}
                color="red.500"
              >
                {formStatus.error}
              </Text>
            )} */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
